import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

dayjs.extend(isSameOrBefore);

const getters = {
  getCurrentExerciseId: (state) => () => state.currentExerciseId,
  getCurrentRunInfo: (state) => () => state.runInfo,
  getCurrentExercise: (state) => () => {
    if (!state.runInfo || !state.runInfo.exercises || !state.currentExerciseId) return null;
    return state.runInfo.exercises.find((ex) => ex.id === state.currentExerciseId) || null;
  },
  isExerciseBlocked: (state) => (exerciseId) => {
    const openExerciseId = state.candidate.selectedExerciseId;
    // block it directly if the exercise feed in is not the assigned one
    if (exerciseId !== state.candidate.selectedExerciseId) return true;
    return false;

    // ---- currently not used ----
    // const timetable = state.timetable.filter( (x) => x.exerciseId === exerciseId).sort((a, b) => dayjs(b.startTime).isSameOrBefore(dayjs(a.startTime)));
    // const isBlocked = !(state.exercises.findIndex((ex) => ex.id === openExerciseId) !== -1 && dayjs().isBetween(dayjs(timetable[0].startTime), dayjs(timetable[timetable.length - 1].endTime)));
    // return isBlocked;
  }
}

export default getters
